/**
 * Client-side fetcher treści katalogu dla doczytywania kolejnych stron
 * (paginacja "Wczytaj więcej").
 *
 * Idzie przez proxy `app/api/cms/catalog-content` (full mode, `include_content=1`),
 * który dokłada X-API-Key i egzekwuje gate `after_login`. Zwraca sam
 * `response_catalog_data` (per-component payload z `C_*_CONTROLLER::getApiContent`).
 */
export async function fetchCatalogPageContent(
  slug: string,
  lang: string,
  opts: { page?: number | null; articleId?: number | null; idCategory?: number | null; archive?: boolean } = {},
): Promise<unknown | null> {
  const qs = new URLSearchParams();
  qs.set("slug", slug);
  qs.set("lang", lang);
  if (opts.page != null) qs.set("page", String(opts.page));
  if (opts.articleId != null) qs.set("article_id", String(opts.articleId));
  if (opts.idCategory != null) qs.set("id_category", String(opts.idCategory));
  if (opts.archive) qs.set("archive", "1");

  try {
    const res = await fetch(`/api/cms/catalog-content?${qs.toString()}`, {
      cache: "no-store",
    });
    if (!res.ok) return null;
    const body = (await res.json()) as { content?: unknown };
    return body.content ?? null;
  } catch {
    return null;
  }
}
